<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
    <!-- <LogoHeader :logoPath="require('@/assets/logo/elm/elm-telecom.png')" altText="中国电信"/> -->
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/top/jd/jd_telecom.png" class="topImg" alt="" />
      <div class="contentBox1">
        <div class="tcInfo">
          <div class="tcInfoBox">
            <div class="titleBox"><span class="bigText">39</span>元/月</div>
            <div class="contentBox">
              <div class="blueText"><span class="big">205</span>GB流量</div>
              <!-- <div class="text">200GB国内通用流量</div> -->
              <!-- <div class="text" v-if="false">60GB国内定向流量</div> -->
              <div class="blueText"><span class="big">300</span>分钟语音</div>
            </div>
            <img
              class="sepeaker"
              src="@/assets/GuangzhouUnicomImg/speaker.png"
              alt=""
            />
            <img
              class="xpImg"
              src="@/assets/GuangzhouUnicomImg/xp.png"
              alt=""
            />
            <div class="bottomBg"></div>
          </div>
        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>


            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="街道小区门牌号等(无需重复省市区)"
              />
            </div>
            
            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="随收货城市"
              />
              <!-- <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                />
              </van-popup> -->
            </div>

            <div v-if="false" class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <!-- <div class="form-item" v-if="zpActivety"> -->
            <div class="form-item" v-if="false">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="false">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo" v-if="false">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">资费详情</div>
          <div class="content">
            <table class="zfxqTable">
              <colgroup>
                <col style="width: 20%;" />
                <col style="width: 30%;" />
                <col style="width: 50%;" />
              </colgroup>
              <tr>
                <td class="zTh">原套餐资费</td>
                <td class="zTd" colspan="2"><span class="blueText">79元/月</span></td>
              </tr>
              <tr>
                <td class="zTh">月基本费<br><span style="font-size: 12px">优惠后</span></td>
                <td class="zTd" colspan="2"><span class="blueText">39元/月</span></td>
              </tr>
              <tr>
                <td class="zTh" rowspan="2">套餐内</td>
                <td class="zTd">通用流量</td>
                <td class="zTd">15G</td>
              </tr>
              <tr>
                <td class="zTd">语音</td>
                <td class="zTd">300分钟</td>
              </tr>
              <tr>
                <td class="zTh" rowspan="2">优惠包</td>
                <td class="zTd">国内流量</td>
                <td class="zTd">额外叠加160G通用流量+30G定向流量</td>
              </tr>
              <tr>
                <td class="zTd">月费减免</td>
                <td class="zTd">40元(共24期）</td>
              </tr>
              <tr>
                <td class="zTh">套餐外</td>
                <td class="zTd" colspan="2">国内语音：0.15元/分钟；国内短/彩信：0.1元/条；国内流量：5元/GB</td>
              </tr>
            </table>
          
            
            <div class="section">
              <h3>详细说明</h3>
              <p><strong>（一）套餐方案</strong></p>
              <p>月基本费：79元，国内通用流量：15GB，语音：300分钟</p>
              <p><strong>（二）资费说明</strong></p>
              <p>1.全国接听免费，赠送来电显示、天翼云盘、189邮箱。</p>
              <p>2.套餐超出资费</p>
              <p class="textIndent">（1）国内通用流量：前100MB按0.05元/MB收费，达到100MB（5元）时，额外赠送用户924MB流量（即5元/1GB）;流量超过1GB时，仍按上述原则（即每超出1GB按照5元/1GB收费）收费，以此类推。</p>
              <p class="textIndent">（2）国内通话：0.15元/分钟。</p>
              <p class="textIndent">（3）其他业务按照标准资费执行。</p>
              <p><strong>（三）其他资费说明</strong></p>
              <p>1.国内通话和接听免费范围不包括港澳台地区。</p>
              <p>2.手机上网流量仅限中国大陆境内使用,不含 WLAN(Wi-Fi)上网。</p>
              <p>3.套餐内包含的国内通用流量适用于流量不清零规则。</p>
              <p>4.付费方式：预付费。</p>
              <p>5.可订购各类流量包、语音包及短/彩信包产品。</p>
              <p>6. 上网当月套餐外流量消费600元及600元的倍数则断网，次月初自动开通，如果客户当月申请继续使用，则继续提供服务，按照套外资费收费。套餐外流量消费费用包含按套餐外资费收取的上网流量费，不含用户订购的定向、闲时等各种流量包功能费。</p>
              <p>7、不可办理副卡</p>
              <p>8、快递员上门激活，入网年龄：18周岁-60周岁</p>
              <p>9、拆机提示：号卡激活后，如需拆机的，可下载中国电信官方app，搜索"自助销户"，点击自助销户办理，具体以页面规则为准。</p>
              <p>10、违约金：合约期24个月，中途拆机有违约金</p>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="header">其他说明</div>
          <div class="content">
            <div class="section">
              <p>1、套餐变更、退订，次月生效。</p>
              <p>
                2、套餐中的"国内"指中国内地，不含港澳台地区。(下同)套餐中包含的语音通话分钟数、短/彩信及手机上网流量仅限中国内地使用，手机上网流量只适用于5G、4G、3G、2G，不区分5G、4G、3G、2G，不含WLAN(Wi-Fi)上网。(下同)。
              </p>
              <p>
                3、套餐内包含的以及赠送的国内通信费不含信息费等代收费。(下同)
              </p>
              <p>
                4、上网当月套餐外流量消费600元及600元的倍数则断网，次月初自动开通，如果客户当月申请继续使用，则继续提供服务，按照套外资费收费。
              </p>
              <p>
                5、本套餐所含定向流量为中国电信联合合作方提供，若合作关系发生变化，中国电信有权对相关内容进行调整或停止提供。若用户不同意调整，可申请终止服务协议。
              </p>
              <p>6、流量抵扣顺序：</p>
              <p class="textIndent">
                定向流量包、不限量视频流量包、赠送闲时流量、闲时流量包、非账单支付假日流量包、1天流量包、3天流量包、7天流量包、30天流量包、畅聊流量包后向全国流量月包、赠送全国流量、5G升级会员包流量、套餐内全国流量、非账单支什流景加餐句，流量加餐包，日海目句后向今困流景委包，非账单支付季/半年/年包流量、季/半年/年包流量、不限量升级包、不限量提速包超出后执行套外流量资费，各省根据省内实际情况微调。
              </p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、未满20周岁不能办理新卡入网。</p>
              <p>
                2、请于提交订单15天内激活您的号卡，逾期未能激活的，本订单将自动取消，号卡失效。
              </p>
              <p>
                3、根据工信部要求，您的号卡激活且开通后将由人工对实名照片进行审核，审核不通过的将通过短信方式通知您按要求进行补上传照片操作，逾期若未补上传照片的，号码将被暂停通信服务。
              </p>
              <p>4、50天内已超过3次办理移动号卡拆机业务的用户无法办理此卡。</p>
              <p>5、本套餐不支持副卡。</p>
              <p class="textIndent">套餐条款以页面营销协议为准</p>
              <p>
                6、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。
              </p>
              <p>
                7、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以电信系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
            </div>
          </div>
        </div>
      </div>

      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>

    <!-- 添加升级提示弹窗 -->
    <van-dialog
      v-model="showUpgradeDialog"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
      :show-cancel-button="false"
      class="upgrade-dialog"
    >
      <div class="upgrade-content">
        <div class="upgrade-icon">
          <van-icon name="warning" size="48" color="#ff9500" />
        </div>
        <h3 class="upgrade-title">系统升级维护中</h3>
        <p class="upgrade-message">尊敬的用户：</p>
        <p class="upgrade-message">系统正在进行临时升级维护</p>
        <p class="upgrade-message">暂停下单服务</p>
        <!-- <p class="upgrade-time">预计恢复时间：2024-12-25 18:00</p> -->
        <van-button 
          type="primary" 
          block 
          class="upgrade-btn"
          @click="showUpgradeDialog = false"
        >
          我知道了
        </van-button>
      </div>
    </van-dialog>
    <!-- 半透明套餐快捷按钮 -->
    <!-- <div class="package-btns">
      <a
        class="pkg-btn"
        href="https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=db1edd8AFe&channel=09-2279-bpo9-c5dx&ADTAG=09-2279-bpo9-c5dx"
      >
        38元套餐
      </a>
      <a
        class="pkg-btn"
        href="https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=a81572C3F4&channel=09-2279-bpo9-c5dx&ADTAG=09-2279-bpo9-c5dx"
      >
        58元套餐
      </a>
    </div> -->
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData-330000.json";
import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
// import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "NINGBO-TELECOM-1",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    // LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [
        {
          name: "S",
          value: "S",
        },
        {
          name: "M",
          value: "M",
        },
        {
          name: "L",
          value: "L",
        },
        {
          name: "XL",
          value: "XL",
        },
        {
          name: "2XL",
          value: "2XL",
        },
        {
          name: "3XL",
          value: "3XL",
        },
        {
          name: "4XL",
          value: "4XL",
        },
        {
          name: "5XL",
          value: "5XL",
        },
      ],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      // szData: {
      //   comboCode: "SZLT-LTWK2",
      //   spiId: "shenzhen-uni-01",
      // },
      goodsName: "",
      showUpgradeDialog: false
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.productId = localStorage.getItem("productId");
    this.empId = localStorage.getItem("empId");
    
    console.log("mtBmUid =>", this.mtBmUid);
    console.log("spiId =>", this.spiId);
    console.log("saleId =>", this.saleId);
    console.log("oIndex =>", this.oIndex);
    console.log("channel =>", this.channel);
    console.log("productId =>", this.productId);
    console.log("empId =>", this.empId);
    
    this.areaList = [];
    this.areaList.push(areaData["330000"]);
    //this.areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd"]);
    // this.initAreaList2();
    // this.cardAttribution = "宁波";
    this.cardAttributionProvince = "330000";
    // this.cardAttributionCode = "330200";
    this.comboData = {
      comboLevel: 39,
      abstractImg: "",
      comboName: "39元畅享流量卡",
      showMobile: "true",
      goodsCode: this.oIndex,
      comboCode: this.oIndex,
    };

    this.comboName = this.comboData.comboName;
    this.goodsName = this.comboData.comboName;
    // this.dealTextList = [
    //   {
    //     name: "入网协议",
    //     components: "unicomDeal9",
    //   },
    //   {
    //     name: "用户隐私协议",
    //     components: "ysxy",
    //   },
    // ];
    this.simViewLogAdd();
    //this.getActivityBySpi();
  },
  watch: {
    cardAttribution(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
      }
    },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //     let obj = {};
    //     let arr = [];
    //     console.log("newVal =>", newVal);
    //     if (newVal.includes("西藏") || newVal.includes("新疆")) {
    //       if (newVal.includes("西藏")) {
    //         obj = deepClone(areaData["540000"]);
    //       } else if (newVal.includes("新疆")) {
    //         obj = deepClone(areaData["650000"]);
    //       }

    //       this.contactsCity = "";
    //       this.areaData = [];
    //     } else {
    //       obj = deepClone(areaData["gzuni0000000001"]);
    //     }
    //     arr.push(obj);
    //     this.areaList = arr;
    //     console.log("areaList =>", this.areaList);
    //   }
    // },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: "GZTelecom39-JD",
        spiId: this.spiId,
        clickName: "GZTelecom39-JD",
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: "GZTelecom39-JD",
        spiId: this.spiId,
        clickName: `ERROR-GZTelecom39-JD-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      // window.location.href =
      // "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
      this.$router.push({
        name: "OrderList",
      });
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      this.comboMobile = "random";
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 6) {
        this.$toast("详细地址长度不少于6位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      //判断地址是否包含了省或市或区，如果包含，则提示不能包含省市区
      // 判断是否以省名称开头
      if (this.contactsAddress.startsWith(this.areaData.pName) ) {
        this.$toast("详细地址不能包含省市区");
        return;
      }
      // 去掉"市"字后匹配地市名称
      //if (this.contactsAddress.includes(this.areaData.cName.slice(0, -1))) {
      if (this.contactsAddress.includes(this.areaData.cName)) {
        this.$toast("详细地址不能包含省市区");
        return;
      }
      // 去掉"区"字后匹配区县名称
      //if (this.contactsAddress.includes(this.areaData.aName.slice(0, -1))) {
      if (this.contactsAddress.includes(this.areaData.aName)) {
        this.$toast("详细地址不能包含省市区");
        return;
      }

      let params = {
        comboLevel: this.comboData.comboLevel,
        comboName: this.comboData.comboName,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince: this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.comboData.comboCode,
        goodsCode: this.comboData.goodsCode,
        saleId: this.empId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
        channelProductId: this.productId
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      try {
        const { code, message } = await http("simOrderJd", paramsData);
        if (code == 200) {
          this.dialogTips = {
            text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
            icon: "success",
            iconColor: "#07C160",
            show: true,
            confirmButtonText: "确定",
          };
        } else {
          this.dialogTips = {
            text: message,
            icon: "warning",
            iconColor: "#FF4444",
            show: true,
            confirmButtonText: "关闭",
          };
        }
      } catch (error) {
        this.dialogTips = {
          text: error.message || "提交失败，请稍后重试",
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      } finally {
        this.noClick = false;
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
      if (this.areaData2.cCode == "440300") {
        this.comboData = {
          ...this.comboData,
          comboCode: this.szData.comboCode,
          goodsCode: this.szData.comboCode,
        };
        this.spiId = this.szData.spiId;
      } else {
        const gysCode = localStorage.getItem("gysCode");
        this.comboData = operatorData[gysCode].comboList[this.oIndex];
        this.spiId = gysCode;
      }
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",

        //todo
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;

      this.cardAttribution = this.areaData.cName;
      this.cardAttributionCode = this.areaData.cCode;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } 

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.comboData.comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "ltZOPnumGuessSelect2",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(areaData["440100"]);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
  },
};
</script>

<style lang="less" scoped>

.act {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-image: linear-gradient(135deg, #82c9ff, #fea6ff, #91c4ff, #ebacff);
  .queryBtn {
    position: fixed;
    top: 60vh;
    right: 20px;
    width: 30px;
    z-index: 2;
  }
  .kefuBtn {
    position: fixed;
    top: 50vh;
    right: 5px;
    width: 60px;
    z-index: 2;
    color: #7a8ebb;
  }
  .act-bg {
    width: 100%;
    display: block;
  }
  .topImg {
    padding-top: 30px;
    width: 100%;
    display: block;
  }
  .bottomImg {
    width: 100%;
    padding-top: 50px;
    display: block;
  }
  .bottomBtn {
    width: 100%;
    position: fixed;
    bottom: 43vw;
    left: 0;
    padding: 40px 40px;
    box-sizing: border-box;
    z-index: 2;
    .bottomBtnImg {
      width: 100%;
    }
  }
  .content {
    width: 100%;
    // position: absolute;
    // top: 105vw;
    .contentBox1 {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      .tcInfo {
        width: 100%;
        position: relative;
        .tcInfoImg {
          width: 100%;
        }
        .tcInfoBox {
          background-color: #fff;
          padding-bottom: 40px;
          border-radius: 10px;
          position: relative;
          .titleBox {
            color: #3960ce;
            font-weight: 600;
            // background-color: #FF3C00;
            //background-image: linear-gradient(to right, #FF3C00, #FE6903);
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            padding: 5px 10px;
            .bigText {
              font-size: 40px;
              font-family: 'Source Han Sans';
            }
          }
          .blckText{
            color: #333;
          }
          .contentBox {
            padding: 5px 20px;
            width: 100%;
            box-sizing: border-box;
            .blueText {
              color: #3960ce;
              font-size: 16px;
              font-weight: 600;
              // padding-top: 5px;
              padding-bottom: 10px;
              .big{
                font-size: 26px;
              }
            }
            .text {
              position: relative;
              padding: 0px 0 0 15px;
              font-size: 15px;
              box-sizing: border-box;
              margin-bottom: 10px;
              &::before {
                content: ""; /* 伪元素内容为空 */
                position: absolute;
                left: 5px; /* 定位到左侧 */
                top: 50%; /* 垂直居中 */
                transform: translateY(
                  -50%
                ); /* 向上移动50%自身的高度，实现垂直居中 */
                width: 5px; /* 小圆点的宽度 */
                height: 5px; /* 小圆点的高度 */
                background-color: #333; /* 小圆点的颜色 */
                border-radius: 50%; /* 使背景变成圆形 */
              }
            }
            .smallText{
              font-size: 12px;
              padding: 0 0 10px 20px;
              margin-top: -5px;
              color: #696767;
              width: 80%;
              box-sizing: border-box;
            }
          }
          .sepeaker{
            position: absolute;
            bottom: 20px;
            right: 10px;
            width: 85px;
            z-index: 1;
          }
          .xpImg{
            position: absolute;
            top: 50px;
            right: 20px;
            width: 60px;
            z-index: 1;
          }
          .bottomBg{
            width: 100%;
            height: 18px;
            position: absolute;
            bottom: 0;
            left: 0;
            background-image: linear-gradient(to right, #00D9FA, #0559D4);
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
        }
      }
      .xssInfo {
        width: 100%;
        position: relative;
        padding-top: 20px;
        .xssInfoImg {
          width: 100%;
        }
        .xssConent {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          height: 13vw;
          line-height: 13vw;
        }
      }
      .bmInfo {
        background-color: #fff;
        border-radius: 15px;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        .bmTitle {
          text-align: center;
          font-weight: 600;
          color: #3860cf;
          font-size: 20px;
        }
        .bmContent {
          width: 100%;
          padding: 10px 0;
          .scroll-content {
            height: 120px;
            overflow: hidden;
          }
          .bmItem {
            width: 100%;
            display: flex;
            border-bottom: 1px solid #cdd8f3;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            box-sizing: border-box;
            .bmItemName {
              width: 30%;
            }
            .bmItemPhone {
              width: 40%;
            }
            .bmItemTime {
              width: 30%;
              text-align: right;
            }
          }
        }
      }
      .tcysInfo {
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        .tcysImg {
          width: 100%;
        }
      }
      .zfxqInfo {
        width: 100%;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;
        .boxImg {
          width: 100%;
        }
      }
    }
    .contentBox2 {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      .userInfo {
        width: 100%;
        background-color: #fff;
        padding: 30px 20px;
        font-size: 14px;
        box-sizing: border-box;
        border-radius: 13px;
        .form-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #eee;
          .form-label {
            width: 30vw;
          }
          /deep/.van-field__control {
            text-align: right;
          }
        }
        .dealText {
          padding: 20px 0;
          width: 100%;
          box-sizing: border-box;
          .read {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            word-wrap: break-word;
            overflow-wrap: break-word;
            white-space: normal;
            font-size: 12px;
            color: #cec9cc;
            .van-checkbox {
              margin-right: 4px;
            }
            .deal {
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
            }
            .xy {
              color: #3860cf;
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
            }
          }
        }
      }
      .btn {
        width: 100%;
        .lqBtn {
          width: 100%;
        }
      }
    }
  }
}
.numDialog {
  height: 20rem;
  .numClose {
    position: fixed;
    top: 0;
    left: 0;
    width: 90%;
    height: 1.5rem;
    background-color: #fff;
    padding: 0.8rem 1.5rem 0.6rem 0.8rem;
    text-align: right;
  }
  .numBox {
    margin-top: 1.8rem;
    height: 14rem;
    overflow: hidden;
    overflow-y: scroll;
    .numContent {
      display: inline-block;
      width: 50%;
      line-height: 4rem;
      span {
        display: flex;
        justify-content: space-around;
      }
    }
  }
  .numBtn {
    position: fixed;
    left: 35%;
    bottom: 0.8rem;
    text-align: center;
  }
}
.kefuBox {
  width: 100%;
  display: flex;
  padding-top: 10px;
  justify-content: center;
  align-items: center;
  .kefuQRCode {
    width: 40%;
  }
}
.sizeBox {
  padding: 20px;
  .sizeBoxList {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .sItem {
      border: 1px solid #eee;
      margin-right: 10px;
      margin-bottom: 10px;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      &.active {
        border-color: #338fcc;
        color: #338fcc;
      }
    }
  }
}
.activeInfo {
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .activeLeft {
    color: #e03737;
  }
  .activeRight {
    color: #5186db;
  }
}
.dialogTips {
  width: 100%;
  max-height: 70vh;
  overflow: scroll;
  background-color: #e03737;
  .tipsImg {
    width: 100%;
    display: block;
  }
}
select {
  font-size: 14px;
  text-align: right;
  width: 30%;
  height: 44px;
  /* 去除默认的边框 */
  border: none;

  /* 去除默认的内边距 */
  padding: 0;

  /* 去除默认的外边距 */
  margin: 0;

  /* 去除背景色 */
  background-color: #fff;

  /* 增加一些自定义样式 */
  /* 例如： */
  font-family: "Arial", sans-serif;
  color: #333;
  /* 你可以添加更多的自定义样式 */
  option {
    background-color: #fff;
    border: none;

    /* 去除默认的内边距 */
    padding: 0;

    /* 去除默认的外边距 */
    margin: 0;
  }
}


.container {
  background-color: #fff;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  // padding: 20px;
  box-sizing: border-box;
  margin-top: 20px;
  .header {
    background-size: cover;
    background-position: center;
    text-align: left;
    font-size: 22px;
    font-weight: bold;
    color: #3e5fb2;
    border-radius: 10px 10px 0 0;
    box-sizing: border-box;
    height: 60px;
    padding-left: 20px;
    padding-top: 7px;
  }
  .content {
    width: 100%;
    // height: 200px;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    .zfxqTable {
      border: 1px solid #799ffd;
      border-radius: 10px;
      .zTr {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #799ffd;
        &:last-child {
          border-bottom: none;
        }
        .zTh {
          padding: 10px;
          width: 25%;
          box-sizing: border-box;
          color: #3e5fb2;
          font-weight: 600;
          text-align: center;
        }
        .zTd {
          width: 75%;
          padding: 10px;
          box-sizing: border-box;
          border-left: 1px solid #799ffd;
          font-size: 13px;
          .blueText{
            color: #3e5fb2;
            font-weight: 600;
            font-size: 16px;
          }
        }
      }
    }

    .section {
      margin-bottom: 20px;
    }

    .section h3 {
      font-size: 16px;
      color: #3e5fb2;
      margin-bottom: 10px;
    }
    .section p {
      font-size: 12px;
      color: #555;
      line-height: 1.8;
      margin: 5px 0;
    }
    .section a {
      font-size: 12px;
      line-height: 1.8;
      margin: 5px 0;
    }
    
    .section p strong {
      color: #3e5fb2;
    }
    .link {
      font-size: 14px;
      color: #0066cc;
      text-decoration: underline;
    }
    .note {
      font-size: 12px;
      color: #999;
      margin-top: 10px;
    }
  }
}

.fzBox{
  width: 100%;

  .fzImg{
    border-radius: 10px;
    width: 100%;
  }
}

.small {
  font-size: 10px;
  // color: #999;
}
.pBottom {
  padding-bottom: 3px;
}
.textIndent {
  padding-left: 10px;
}








// 升级提示弹窗样式
.upgrade-dialog {
  .van-dialog {
    width: 80%;
    max-width: 300px;
    border-radius: 12px;
    overflow: hidden;
  }

  .upgrade-content {
    padding: 20px;
    text-align: center;
    background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
  }

  .upgrade-icon {
    margin: 10px 0 20px;
    animation: bounce 2s infinite;
  }

  .upgrade-title {
    color: #ff6b00;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .upgrade-message {
    color: #333;
    margin: 8px 0;
    font-size: 15px;
    line-height: 1.5;
  }

  .upgrade-time {
    color: #ff6b00;
    font-weight: bold;
    margin: 15px 0 20px;
    font-size: 14px;
  }

  .upgrade-btn {
    background: linear-gradient(to right, #ff9500, #ff6b00);
    border: none;
    border-radius: 25px;
    height: 44px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    box-shadow: 0 4px 8px rgba(255, 107, 0, 0.2);
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
}
.package-btns {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 999;
}
.pkg-btn {
  min-width: 120px;
  padding: 10px 16px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 14px;
  border-radius: 24px;
  text-align: center;
  text-decoration: none;
}
.pkg-btn:active {
  opacity: 0.8;
}


.zfxqTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #799ffd;
  
  tr {
    border-bottom: 1px solid #799ffd;
    &:last-child {
      border-bottom: none;
    }
  }
  
  .zTh, .zTd {
    padding: 10px 8px;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 1.6;
    vertical-align: middle;
    font-weight: normal;
    border-left: 1px solid #799ffd;
    border-right: 1px solid #799ffd;
    text-align: center;
    
    &:first-child {
      border-left: none;
    }
    
    &:last-child {
      border-right: none;
    }
  }
  
  .zTh {
    color: #3e5fb2;
    font-size: 13px;
    font-weight: bold;
    background-color: #f5f8ff;
  }
  
  .zTd {
    color: #333;
    
    .blueText {
      color: #3e5fb2 !important;
      font-weight: bold !important;
      font-size: 18px !important;
    }
    .blueText2 {
      color: #3e5fb2 !important;
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.zfxqTable3 {
  .zTr {
    display: flex;
    align-items: stretch;
    border-bottom: 1px solid #799ffd;
    &:last-child {
      border-bottom: none;
    }
    .zTh, .zTd, .z3Td {
      padding: 8px 10px;
      margin: 0;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 1.5;
      vertical-align: middle;
      font-weight: normal;
    }
    .zTh {
      color: #3e5fb2;
      text-align: center;
      font-size: 12px;
      width: 18%;
      font-weight: bold;
    }
    .zTd {
      width: 33%;
      border-left: 1px solid #799ffd;
      .blueText {
        color: #3e5fb2 !important;
        font-weight: bold !important;
        font-size: 18px !important;
      }
      .blueText2 {
        color: #3e5fb2 !important;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
}
</style>

